window.productDetailsCustomizeHandler = () => {
  document.addEventListener("DOMContentLoaded", () => {
    customizeLoaderEvents();
    setSectionWidth();
    snapModule();
    fullscreenEvents();
    autoLoadCustomizer();
  });

  window.addEventListener('resize', () => {
    setSectionWidth();
  });

  const customizeLoaderEvents = () => {
    $('.jsProductCustomizeLoad').on('click', (e) => {
      const URL = window.location.pathname + 'customizer/';
      setCustomize(URL)
    })
  };

  // Set section width fitted to browser width
  const setSectionWidth = () => {
    const section = document.querySelector('.jsProductCustomize');

    if(section) {
      const sectionWidth = section.querySelector('.jsProductCustomizeWidth').clientWidth;
      const sectionMainContainer = section.querySelector('.jsProductCustomize');
      sectionMainContainer.style.width = `${sectionWidth + ((section.clientWidth - sectionWidth) / 2)}px`;
    }
  };

  const snapModule = () => {
    const customizeSection = document.querySelector('.jsProductCustomize');
    const bodyChildren = Array.prototype.slice.call(document.body.children).filter(el => el.tagName !== "SCRIPT");
    const customizeSectionIdx = bodyChildren.indexOf(customizeSection);
    const prevElement = bodyChildren[customizeSectionIdx - 1];

    window.addEventListener('scroll', (e) => {
      const sectionPosition = customizeSection?.getBoundingClientRect().top;
      const customizeTopPosition = prevElement?.getBoundingClientRect().bottom + window.scrollY;

      if (customizeSection) {
        // Unblock sticky if user scrolled module more than 1/5 of module height
        if (customizeTopPosition + customizeSection.offsetHeight / 4 < window.pageYOffset) {
          customizeSection.style.position = 'static';
        } else {
          customizeSection.style.position = sectionPosition > 0 ? 'static' : 'sticky';
        }
      }
    });
  };

  // Set full screen
  const fullscreenEvents = () => {
    window.addEventListener('click', (e) => {
      const isClickedFullScreenBtn = e.target.classList.contains('jsCustomizerFullScreenBtn');
      const customizeContainer = document.querySelector('.jsCustomizeContainer');

      if (isClickedFullScreenBtn) {
        scrollToDest('#customize', 57, 300);

        setTimeout(() => {
          customizeContainer.classList.toggle('fullscreen');
          document.body.classList.toggle('block-scroll');
        }, 800);
      }
    })
  }

  // auth load customizer when user chose customizer from navigation
  const autoLoadCustomizer = () => {
    const load = () => {
      if(window.location.hash === '#product-customizer-container') {
        document.querySelector('.jsProductCustomizeLoader').click();
      }
    }
    load()
    window.addEventListener("hashchange", load);
  }
};
